import React from "react";
import { Navigate, useLocation } from "react-router";
import PropTypes from "prop-types";
import useAuth from "../hooks/useAuth";
import { usePermissions } from "../contexts/permissions";
import DashboardRedirect from "./DashboardRedirect";
import { buildLoginRedirectUrl } from "../utils/authReturnTo";

const DashboardGuard = ({ children }) => {
  const { isAuthenticated } = useAuth();
  const { can } = usePermissions();
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to={buildLoginRedirectUrl(location)} replace />;
  }

  if (!can("pages.dashboard")) {
    return <DashboardRedirect />;
  }

  return children;
};

DashboardGuard.propTypes = {
  children: PropTypes.node,
};

export default DashboardGuard;
